import { Transforms } from 'vendor/slate'
import { ELEMENT_TYPES } from 'cg/components/documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'

const insertGraphiql = (editor, path) => {
  const graphiql = {
    type: ELEMENT_TYPES.graphiql,
    url: 'https://api.github.com/graphql',
    children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.graphiql } }]
  }

  Transforms.insertNodes(editor, graphiql, { at: path })
}

export { insertGraphiql }
